export const replaceHistory = (path: string, searchParams: URLSearchParams) => {
  const hasSearchParams = !!searchParams.toString();
  window.history.replaceState(
    {},
    'null',
    hasSearchParams ? `${path}?${searchParams.toString()}` : path,
  );
  // this is needed to update the query object in the router (go back not working without this)
  const query = {};
  searchParams.forEach((value, key) => {
    query[key] = value;
  });
  navigateTo({ path, query });
};
